__turbopack_context__.v({
  "SActions": "KlnP_q_SActions",
  "SHeading": "KlnP_q_SHeading",
  "SNoReviews": "KlnP_q_SNoReviews",
  "SReviews": "KlnP_q_SReviews",
  "SSeeMoreButton": "KlnP_q_SSeeMoreButton",
  "SUserReviewsContainer": "KlnP_q_SUserReviewsContainer",
  "SWriteReviewButton": "KlnP_q_SWriteReviewButton",
  "show-desktop": "KlnP_q_show-desktop",
  "show-mobile": "KlnP_q_show-mobile",
});
